import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=0229ccdd&scoped=true&"
import script from "./Time.vue?vue&type=script&lang=js&"
export * from "./Time.vue?vue&type=script&lang=js&"
import style0 from "./Time.vue?vue&type=style&index=0&id=0229ccdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0229ccdd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/kanghuang/project/Javascript/vue/letter_en/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout,VSheet})
